import request from '@/utils/request'

// v80CocwNdt
export function v80CocwNdt(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080/v80CocwNdt`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1080List
export function v80a1080List(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080/v80a1080List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1080Update
export function v80a1080Update(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080/v80a1080Update`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1080Delete
export function v80a1080Delete(param) {
  let data = param
  return request({
    url: `/inspection/v80a1080/v80a1080Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}